export const fuzzyMatchOption = (input, option) => {
  const label = (option.label ?? option.value ?? '').toLowerCase();
  const inputStr = input.toLowerCase();

  let currentIndex = 0;

  return Array.from(inputStr).every((char) => {
    const index = label.indexOf(char, currentIndex);
    if (index === -1) return false;
    currentIndex = index + 1;
    return true;
  });
};
